let isRunning = false;

async function scheduleSync() {
  try {
    const reg = await navigator.serviceWorker.ready;
    await reg.sync.register('sync-rrweb-logs');
    console.log('[SYNC] agendado');
  } catch (err) {
    console.warn('[SYNC] fallback necessário', err);
  }
}

async function orchestrate() {
  if (isRunning) return; // evita concorrência
  isRunning = true;

  try {
    await scheduleSync();
  } finally {
    isRunning = false;
  }
}

function start() {
  // roda ao iniciar
  orchestrate();

  // roda periodicamente
  setInterval(orchestrate, 120000);

  // reage a mudança de rede
  navigator.connection?.addEventListener('change', orchestrate);

  // quando volta online
  window.addEventListener('online', orchestrate);

  // quando usuário volta pro app
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      orchestrate();
    }
  });
}

start();